/** @format */

import styled from 'styled-components';

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: var(--grey-100);
  position: relative;
`;
